import styles from './Left.module.css'

function Left() {
    return (
        <div className={styles.container} >
        </div>
    )
}

export default Left
